import { useParams } from "react-router-dom";

import { EmptyState, LoadingState } from "~/common/components";
import {
  useGetConsultationCompletionDetails,
  useGetConsultationReport,
  useGetPatient,
  useIsTeamMemberStaff,
} from "~/providers/hooks";
import { isConsultationCompleted, PatientParams } from "~/providers/utils";
import { ConsultationReportForm } from "./ConsultationReportForm";
import { SubmittedConsultationReport } from "./SubmittedConsultationReport";

export const ConsultationReport = () => {
  const { patientId } = useParams<keyof PatientParams>() as PatientParams;
  const { data: patientData } = useGetPatient(patientId);
  const { isStaff } = useIsTeamMemberStaff();
  const consultationId = patientData?.consultation?.id;
  const consultationStatus = patientData?.consultation?.status;

  const { data: completedReportData, isLoading } = useGetConsultationReport(
    consultationId,
    { enabled: isConsultationCompleted(consultationStatus) },
  );
  const { data: completedDataConsultationData } =
    useGetConsultationCompletionDetails(consultationId, !completedReportData);
  if (!patientData) {
    return null;
  }

  const isPatientConsultationCompleteWithoutData =
    !completedDataConsultationData &&
    isConsultationCompleted(consultationStatus);

  if (isLoading) return <LoadingState className="h-screen-calculated" />;

  if (!!completedReportData?.completed_at && completedReportData) {
    return <SubmittedConsultationReport data={completedReportData} />;
  }

  if (isStaff || isPatientConsultationCompleteWithoutData) {
    return (
      <EmptyState
        message="No consultation report (H&P) available for this patient."
        messageClassName="lg:w-1/4"
      />
    );
  }

  return (
    <ConsultationReportForm
      patientStatus={patientData?.status}
      patientConsultationStatus={consultationStatus}
      data={completedReportData}
    />
  );
};
